var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundArrecadacoes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 314,
    viewBox: "0 0 318 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_761_1544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.35 66.4774C219.906 -15.6897 62.5881 -20.2763 16.3215 44.8899C-9.16155 80.7981 1.48256 134.47 6.74293 160.958C16.4112 209.695 40.2568 241.073 45.4723 247.723C58.1016 263.871 88.8002 303.099 134.977 312.059C213.871 327.378 312.327 249.371 317.778 161.373C320.907 110.639 292.093 73.5873 286.35 66.4774Z",
    fill: "#EBF3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.039 195.543C238.391 183.734 246.769 151.583 238.189 141.108C233.725 135.658 226.524 138.327 222.688 132.047C218.426 125.083 225.167 118.366 227.13 101.477C228.139 92.7412 229.979 76.9178 221.757 69.8192C213.603 62.7878 203.677 71.3556 194.491 64.2793C185.798 57.5844 191.361 47.3682 181.39 35.3801C180.459 34.2699 169.871 21.8445 159.317 24.3116C148.594 26.8124 141.708 43.8021 145.016 55.8013C148.022 66.7016 158.554 70.2678 156.917 76.0992C155.111 82.525 141.73 80.2821 139.251 86.7079C135.662 95.9821 160.988 107.432 159.014 122.717C157.859 131.711 148.572 131.789 144.657 142.723C139.599 156.842 148.841 174.056 157.848 183.397C170.858 196.911 194.794 205.781 215.039 195.543Z",
    fill: "url(#paint0_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M202.004 207.935L202.834 207.856C199.985 175.862 195.498 145.875 189.498 118.714C184.697 96.9807 178.932 76.9969 172.359 59.3344C161.154 29.224 151.329 16.0696 151.228 15.9463L150.566 16.4509C150.667 16.5743 160.425 29.6614 171.597 59.6932C181.904 87.3813 195.554 135.603 202.004 207.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M173.325 62.2498C181.928 38.0158 177.071 16.3273 177.026 16.1143L176.219 16.3049C176.263 16.518 181.064 37.9933 172.551 61.9807L173.325 62.2498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M190.431 122.583C207.547 100.412 214.198 83.7924 216.767 73.7556C219.56 62.8217 218.292 57.2257 218.236 56.9902L217.428 57.1809C217.44 57.2369 218.707 62.8777 215.937 73.6435C213.379 83.5905 206.762 100.064 189.77 122.078L190.431 122.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M199.773 180.763C237.65 149.722 243.471 121.439 243.527 121.159L242.709 121.002C242.697 121.069 241.161 128.403 234.779 139.562C229.16 149.385 218.426 164.401 199.246 180.124L199.773 180.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M179.63 112.68C182.345 113.611 185.16 114.407 188.065 115.047L188.244 114.239C169.255 110.101 154.181 98.7858 144.883 90.0275C134.799 80.529 129.158 71.9164 129.102 71.8379L128.406 72.2865C128.462 72.3762 134.16 81.0673 144.311 90.633C152.274 98.1242 164.421 107.466 179.63 112.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M193.423 168.741C194.893 169.246 196.396 169.705 197.943 170.109L198.157 169.302C178.562 164.121 165.338 150.843 157.7 140.616C149.411 129.525 145.71 119.555 145.676 119.454L144.902 119.734C144.936 119.835 148.671 129.928 157.038 141.109C164.149 150.652 176.072 162.797 193.423 168.741Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.086 241.017C193.93 228.087 184.273 192.336 193.729 180.572C198.652 174.449 206.706 177.354 210.923 170.311C215.6 162.506 208.018 155.093 205.663 136.276C204.44 126.553 202.23 108.924 211.327 100.928C220.344 92.9998 231.493 102.465 241.666 94.4688C251.29 86.9104 244.975 75.584 255.978 62.1156C256.999 60.8596 268.686 46.909 280.474 49.5444C292.453 52.2246 300.304 71.0983 296.738 84.4993C293.507 96.678 281.798 100.771 283.682 107.253C285.757 114.397 300.652 111.761 303.49 118.894C307.595 129.199 279.465 142.219 281.82 159.243C283.2 169.257 296.02 170.087 294.124 182.905C291.062 203.561 286.935 208.507 276.997 219.015C262.607 234.255 242.754 252.231 220.086 241.017Z",
    fill: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M234.732 254.699L233.812 254.62C236.673 218.925 241.361 185.45 247.765 155.105C252.891 130.826 259.116 108.498 266.272 88.7272C278.464 55.0395 289.276 40.2815 289.377 40.1357L290.118 40.6852C290.005 40.831 279.26 55.5217 267.113 89.0973C255.908 120.116 241.193 174.001 234.732 254.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M265.219 92.0133C255.383 65.0877 260.576 40.8537 260.62 40.6182L261.529 40.82C261.473 41.0555 256.347 65.0429 266.083 91.6993L265.219 92.0133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M246.77 159.444C227.467 134.907 219.874 116.449 216.913 105.279C213.683 93.1229 215.04 86.8654 215.096 86.6074L215.993 86.8093C215.982 86.8766 214.625 93.1678 217.821 105.145C220.771 116.213 228.308 134.504 247.488 158.872L246.77 159.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M236.955 224.397C194.423 190.182 187.638 158.715 187.57 158.401L188.479 158.222C188.49 158.3 190.273 166.453 197.508 178.822C203.879 189.723 215.992 206.342 237.527 223.679L236.955 224.397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M258.715 148.297C255.698 149.362 252.569 150.282 249.339 151.022L249.137 150.125C270.268 145.314 286.946 132.552 297.22 122.695C308.358 112.007 314.572 102.352 314.628 102.251L315.413 102.744C315.346 102.845 309.087 112.591 297.86 123.356C289.066 131.789 275.618 142.331 258.715 148.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M243.908 210.93C242.282 211.502 240.611 212.029 238.883 212.5L238.637 211.603C260.418 205.625 275.033 190.688 283.445 179.205C292.575 166.757 296.59 155.598 296.635 155.486L297.51 155.8C297.465 155.912 293.405 167.194 284.197 179.754C276.357 190.464 263.189 204.123 243.908 210.93Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.166 47.6499C245.166 65.3012 231.359 79.1844 213.716 78.6462C195.355 78.0854 179.91 62.2284 179.91 43.2539C179.91 24.2793 195.355 10.5082 213.716 12.4146C231.359 14.2537 245.166 29.9986 245.166 47.6499Z",
    fill: "url(#paint1_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.931 46.1245C249.931 63.7758 236.124 77.6591 218.481 77.1208C200.12 76.5601 184.676 60.703 184.676 41.7285C184.676 22.7539 200.12 8.98276 218.481 10.8892C236.124 12.7283 249.931 28.4732 249.931 46.1245Z",
    fill: "url(#paint2_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.541 46.0356C248.541 62.9131 235.328 76.1684 218.471 75.6189C200.962 75.047 186.258 59.9189 186.258 41.8415C186.258 23.7641 200.962 10.6097 218.471 12.404C235.328 14.131 248.541 29.1581 248.541 46.0356Z",
    fill: "url(#paint3_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.555 45.9672C247.555 62.284 234.768 75.0907 218.482 74.5412C201.58 73.9693 187.402 59.3571 187.402 41.9189C187.402 24.4807 201.58 11.7749 218.482 13.4795C234.768 15.128 247.555 29.6505 247.555 45.9672Z",
    fill: "url(#paint4_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.313 19.0307C219.177 19.1092 219.883 19.8942 219.883 20.7689V23.7744C221.622 23.965 223.349 24.2678 225.087 24.6827C226.366 24.9855 227.645 25.3444 228.912 25.7593C229.675 26.006 230.191 26.7686 230.112 27.5648L229.742 31.3328C229.641 32.3309 228.654 32.914 227.723 32.4991C226.893 32.129 226.041 31.815 225.166 31.5459C223.641 31.0861 222.025 30.7833 220.332 30.6375L219.883 30.6039V39.2052C224.403 40.4725 227.723 42.177 229.877 44.3077C232.008 46.4384 233.073 49.0962 233.073 52.2811C233.073 55.7239 231.896 58.4938 229.529 60.5684C227.151 62.6655 223.82 63.843 219.513 64.0897V67.4092C219.513 68.2951 218.806 68.9792 217.943 68.9455H217.92C217.046 68.9119 216.35 68.1717 216.35 67.2858V64.0112L215.655 63.9776C213.636 63.8879 211.707 63.686 209.856 63.3608C208.488 63.1253 207.153 62.8113 205.852 62.4412C205.067 62.2169 204.517 61.4656 204.596 60.6582L205.033 55.8136C205.123 54.7707 206.177 54.1539 207.175 54.5464C208.331 55.0062 209.508 55.3874 210.697 55.7015C212.548 56.1949 214.432 56.5089 216.339 56.6434L216.361 47.0665C212.021 45.9899 208.768 44.3975 206.637 42.2892C204.495 40.1697 203.418 37.467 203.418 34.17C203.418 30.7609 204.584 28.1255 206.906 26.2864C209.217 24.4472 212.514 23.5389 216.754 23.5389V20.4662C216.731 19.5914 217.438 18.941 218.313 19.0307ZM216.731 30.5142C215.386 30.6151 214.342 30.9852 213.591 31.6244C212.839 32.2636 212.469 33.1271 212.469 34.2037C212.469 35.2242 212.817 36.0877 213.512 36.7717C214.208 37.4558 215.285 38.0053 216.731 38.4202V30.5142ZM219.513 47.8514V56.6322C220.971 56.6322 222.093 56.2846 222.867 55.5893C223.641 54.894 224.033 53.9072 224.033 52.6399C224.033 51.4737 223.674 50.5204 222.945 49.7467C222.227 48.9729 221.083 48.3449 219.513 47.8514Z",
    fill: "url(#paint5_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M213.211 49.9703C214.198 40.27 223.115 36.1655 221.948 27.2389C221.23 21.7439 217.058 17.1012 212.414 13.4902C198.304 14.9705 187.402 26.6446 187.402 41.9184C187.402 59.3567 201.58 73.9801 218.482 74.5408C220.12 74.5969 221.724 74.5072 223.283 74.3053C216.564 67.6328 212.369 58.3025 213.211 49.9703Z",
    fill: "url(#paint6_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.959 102.98C285.959 116.482 275.405 127.102 261.912 126.687C247.869 126.261 236.059 114.127 236.059 99.6266C236.059 85.1154 247.869 74.5852 261.912 76.043C275.405 77.4336 285.959 89.4777 285.959 102.98Z",
    fill: "url(#paint7_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.604 101.814C289.604 115.316 279.049 125.936 265.556 125.521C251.514 125.095 239.703 112.961 239.703 98.4606C239.703 83.9494 251.514 73.4192 265.556 74.877C279.049 76.2788 289.604 88.3117 289.604 101.814Z",
    fill: "url(#paint8_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.55 101.747C288.55 114.655 278.444 124.781 265.556 124.366C252.164 123.929 240.926 112.367 240.926 98.5398C240.926 84.7126 252.164 74.6534 265.556 76.0327C278.444 77.3448 288.55 88.8394 288.55 101.747Z",
    fill: "url(#paint9_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.786 101.69C287.786 114.172 278.017 123.951 265.556 123.536C252.635 123.098 241.789 111.929 241.789 98.584C241.789 85.2389 252.624 75.5274 265.556 76.8394C278.017 78.1067 287.786 89.2088 287.786 101.69Z",
    fill: "url(#paint10_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.434 81.0893C266.096 81.1566 266.634 81.7509 266.634 82.4238V84.7227C267.958 84.8685 269.293 85.104 270.616 85.418C271.592 85.6535 272.568 85.9227 273.532 86.2367C274.115 86.4273 274.508 87.0105 274.452 87.616L274.172 90.4981C274.093 91.2607 273.342 91.7093 272.635 91.3953C271.996 91.1149 271.345 90.8682 270.672 90.6663C269.506 90.3075 268.272 90.0832 266.971 89.971L266.634 89.9486V96.5314C270.089 97.4958 272.635 98.7967 274.272 100.434C275.91 102.06 276.718 104.09 276.718 106.535C276.718 109.17 275.82 111.278 274.015 112.871C272.197 114.474 269.651 115.371 266.354 115.562V118.097C266.354 118.769 265.816 119.296 265.154 119.263H265.131C264.47 119.24 263.931 118.668 263.931 117.996V115.495L263.393 115.472C261.845 115.405 260.376 115.248 258.962 115.001C257.919 114.822 256.899 114.586 255.9 114.295C255.295 114.115 254.88 113.544 254.936 112.927L255.272 109.226C255.34 108.43 256.147 107.959 256.91 108.262C257.796 108.609 258.693 108.912 259.602 109.147C261.015 109.518 262.451 109.764 263.909 109.865L263.931 102.542C260.611 101.724 258.121 100.501 256.495 98.8976C254.857 97.2828 254.027 95.2081 254.027 92.6849C254.027 90.0832 254.925 88.0646 256.697 86.6516C258.469 85.2498 260.981 84.5433 264.223 84.5545V82.1995C264.234 81.5267 264.772 81.0332 265.434 81.0893ZM264.234 89.8701C263.213 89.9486 262.406 90.229 261.834 90.7112C261.262 91.2046 260.97 91.855 260.97 92.6849C260.97 93.4699 261.239 94.1203 261.766 94.6474C262.294 95.1745 263.112 95.5894 264.234 95.9034V89.8701ZM266.354 103.125V109.832C267.464 109.832 268.328 109.562 268.922 109.035C269.517 108.497 269.82 107.746 269.82 106.781C269.82 105.895 269.539 105.155 268.99 104.572C268.429 103.989 267.554 103.507 266.354 103.125Z",
    fill: "url(#paint11_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M261.542 104.752C262.293 97.3391 269.113 94.1991 268.226 87.3696C267.677 83.1642 264.492 79.6205 260.936 76.8506C250.146 77.9832 241.812 86.9098 241.812 98.5951C241.812 111.929 252.647 123.11 265.58 123.547C266.836 123.592 268.058 123.524 269.247 123.367C264.099 118.254 260.891 111.121 261.542 104.752Z",
    fill: "url(#paint12_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5685 143C75.5685 143 45.9477 174.045 51.7544 193.768C57.561 213.491 104 180.095 104 180.095L75.5685 143Z",
    fill: "url(#paint13_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5971 124.38C84.2154 124.02 76.8894 120.808 74.9256 114.687C73.5885 110.519 75.9145 108.249 74.1735 103.997C72.1958 99.1649 68.2681 99.8296 64.6887 95.1493C60.5243 89.6936 59.7583 80.8177 63.0452 75.0158C65.6915 70.3356 68.8113 71.471 73.7835 65.1568C78.1847 59.5765 76.8476 57.2917 79.9535 54.4393C85.9703 48.8867 93.7838 54.9932 104.55 52.5422C119.508 49.1359 119.216 33.9873 130.999 33.0458C141.835 32.1734 155.191 43.9294 157.169 55.2147C157.963 59.7288 156.682 62.1382 158.854 66.0984C162.197 72.1772 168.144 70.5848 172.949 76.6359C176.57 81.2193 178.506 88.8766 175.568 93.4323C172.127 98.7772 164.648 95.7586 161.18 101.007C157.448 106.67 164.258 112.97 160.679 118.924C157.294 124.56 147.698 125.225 142.141 124.948C135.442 124.616 128.937 122.677 122.322 121.611C110.01 119.645 98.6585 126.222 86.5971 124.38Z",
    fill: "url(#paint14_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.41 233.885L99.8058 219.228L96.8672 233.459L150.525 258.22L193.001 247.723L218.63 222.569L158.41 233.885Z",
    fill: "url(#paint15_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7185 157.656C64.2847 151.728 80.9875 135.489 101.946 129.491C117.147 125.136 130.039 127.571 136.756 128.754C158.507 132.594 172.053 143.476 177.157 148.055C172.985 150.323 161.456 157.239 155.754 170.361C150.232 183.038 154.182 194.699 156.24 201.462C158.034 207.363 160.746 216.324 168.785 222.809C173.027 226.232 177.727 227.971 187.115 231.45C198.185 235.555 205.042 236.683 205 238.895C204.93 241.72 193.693 244.03 194.082 245.797C194.11 245.923 194.194 245.936 194.208 246.034C194.361 247.258 181.733 250.292 165.767 252.685C147.103 255.496 137.771 256.902 128.857 255.371C114.949 252.992 117.286 248.706 103.351 246.312C87.1345 243.515 79.7775 248.594 65.0913 242.959C62.6158 242.012 52.7276 238.185 53.0058 234.233C53.3534 229.335 69.6668 231.005 83.8802 218.453C90.1385 212.929 93.1703 207.126 94.2134 204.955C95.5624 202.144 101.251 187.589 95.5485 171.753C95.2147 170.82 94.9505 170.389 94.5889 169.777C87.6908 157.962 69.0132 163.25 66.7185 157.656Z",
    fill: "url(#paint16_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.609 182.849C134.055 189.614 146.474 209.214 163.755 210.885C173.125 211.79 182.37 207.279 187.905 200.472C196.447 189.962 193.806 176.863 192.878 172.283C187.413 145.25 155.325 133.988 152.389 133C144.578 144.985 144.704 152.544 146.362 157.277C147.725 161.175 151.279 165.351 158.388 173.689C164.724 181.109 167.857 183.754 166.916 186.023C165.792 188.71 159.737 188.904 155.887 188.139C148.764 186.705 144.873 181.025 143.847 179.438C141.923 179.745 138.832 180.524 137.609 182.849Z",
    fill: "url(#paint17_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.751 112C127.751 112 129.167 122.71 133.331 125.152C137.494 127.608 144.234 130.802 144.985 131.675C145.721 132.547 119.17 135.245 106 128.95C110.333 128.091 111.523 127.783 111.523 127.783C112.698 127.461 114.893 126.884 117.102 125.689C118.603 124.884 121.011 123.3 123.234 120.321L123.191 114.389L127.751 112Z",
    fill: "url(#paint18_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.423 117.58C125.423 117.58 121.65 128.581 110.288 127.976C100.115 127.44 98.3378 102 104.764 97.0498C106.911 95.3997 111.477 94.4233 115.019 95.3721C117.507 96.0459 125.205 101.285 124.398 110.086C126.504 108.697 128.719 108.683 129.58 109.673C130.674 110.938 129.32 113.524 129.019 114.115C127.953 116.164 126.23 117.168 125.423 117.58Z",
    fill: "url(#paint19_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.425 253.588C136.772 247.342 128.169 240.983 122.337 236.184C110.851 226.73 105.58 219.587 93.9484 216.772C91.8735 216.267 80.0292 213.396 76.2045 218.656C71.976 224.476 80.1975 236.655 81.1957 238.135C96.0571 260.126 133.9 259.106 145.767 258.388C146.653 256.784 147.539 255.181 148.425 253.588Z",
    fill: "url(#paint20_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M76.2043 218.644C77.3259 217.108 79.1317 216.278 81.1731 215.863C80.4889 218.218 80.4328 220.427 81.2852 222.356C83.607 227.627 90.4825 226.001 95.3166 232.191C100.061 238.269 96.7747 244.123 100.97 246.635C105.781 249.506 111.737 242.8 116.885 246.007C120.385 248.194 119.297 252.332 123.379 254.586C126.195 256.145 128.965 255.405 132.173 255.001C135.852 254.541 140.899 254.44 147.225 255.764C146.743 256.627 146.26 257.491 145.789 258.354C133.923 259.072 96.0793 260.092 81.2179 238.101C80.1973 236.643 71.9758 224.476 76.2043 218.644Z",
    fill: "url(#paint21_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.622 256.874C139.622 256.874 137.491 255.349 134.395 256.392C131.299 257.435 126.376 258.276 126.387 259.79C126.398 261.304 131.311 262.257 134.72 261.629C137.962 261.024 140.53 258.198 139.622 256.874Z",
    fill: "url(#paint22_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.748 254.283L137.051 256.111C137.051 256.111 136.12 257.659 137.376 258.634C138.621 259.61 142.973 257.547 142.973 257.547L142.748 254.283Z",
    fill: "url(#paint23_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.981 228.02C223.664 237.821 202.51 248.419 197.676 250.841C187.806 255.787 169.243 262.762 141.685 260.104C141.315 257.906 140.956 255.708 140.586 253.51C144.231 252.265 149.626 250.236 155.885 247.163C166.563 241.903 170.623 238.158 185.45 229.198C201.848 219.284 206.627 218.006 211.517 219.239C215.689 220.271 221.196 223.467 221.981 228.02Z",
    fill: "url(#paint24_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 193.235L134.675 145L97 159.654L106.583 208L143 193.235Z",
    fill: "url(#paint25_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 143L96.242 159.194L106 208L90.3678 197.62L75 143Z",
    fill: "url(#paint26_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5022 182C86.5022 182 81.5802 177.612 81.0529 172.52C80.5109 167.428 84.2316 163.349 87.8205 162.308C91.4095 161.268 93.3431 162.801 90.9261 167.822C88.509 172.843 84.6857 176.093 86.5022 182Z",
    fill: "url(#paint27_linear_761_1544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.729 193C141.729 193 146.864 189.087 147.823 184.116C148.797 179.131 145.58 174.8 142.208 173.477C138.836 172.154 136.847 173.491 138.724 178.643C140.6 183.796 144.014 187.319 141.729 193Z",
    fill: "url(#paint28_linear_761_1544)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_761_1544",
    x1: 199.011,
    y1: 99.7755,
    x2: 441.685,
    y2: -103.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_761_1544",
    x1: 201.346,
    y1: 49.0326,
    x2: 163.288,
    y2: 61.2485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520724,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_761_1544",
    x1: 232.132,
    y1: 11.1545,
    x2: 198.165,
    y2: 86.1056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEF06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_761_1544",
    x1: 225.883,
    y1: 90.2911,
    x2: 219.329,
    y2: 54.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520724,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_761_1544",
    x1: 211.983,
    y1: 32.3296,
    x2: 238.994,
    y2: 89.6771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520724,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_761_1544",
    x1: 210.906,
    y1: 19.9901,
    x2: 224.487,
    y2: 70.8987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEF06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_761_1544",
    x1: 204.035,
    y1: 36.0402,
    x2: 230.991,
    y2: 93.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520724,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_761_1544",
    x1: 252.461,
    y1: 104.033,
    x2: 223.361,
    y2: 113.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520724,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_761_1544",
    x1: 276.001,
    y1: 75.0712,
    x2: 250.029,
    y2: 132.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEF06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_761_1544",
    x1: 271.222,
    y1: 135.581,
    x2: 266.211,
    y2: 108.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520724,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_761_1544",
    x1: 260.594,
    y1: 91.2623,
    x2: 281.247,
    y2: 135.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520724,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_761_1544",
    x1: 259.772,
    y1: 81.8267,
    x2: 270.157,
    y2: 120.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEF06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_761_1544",
    x1: 254.517,
    y1: 94.0998,
    x2: 275.128,
    y2: 137.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520724,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_761_1544",
    x1: 75.9958,
    y1: 195.096,
    x2: 69.9894,
    y2: 242.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0984598,
    stopColor: "#FEBC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_761_1544",
    x1: 59.8876,
    y1: 44.7681,
    x2: 150.17,
    y2: 105.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_761_1544",
    x1: 157.084,
    y1: 214.84,
    x2: 158.34,
    y2: 239.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#893976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_761_1544",
    x1: 125.06,
    y1: 205.96,
    x2: 133.272,
    y2: 270.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_761_1544",
    x1: 167.921,
    y1: 201.573,
    x2: 176.038,
    y2: 265.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0984598,
    stopColor: "#FEBC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_761_1544",
    x1: 126.247,
    y1: 96.6125,
    x2: 125.494,
    y2: 134.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_761_1544",
    x1: 160.542,
    y1: 73.4138,
    x2: 105.961,
    y2: 115.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_761_1544",
    x1: 148.43,
    y1: 237.094,
    x2: 75.0015,
    y2: 237.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#893976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_761_1544",
    x1: 148.43,
    y1: 237.265,
    x2: 75.0015,
    y2: 237.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#893976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_761_1544",
    x1: 127.638,
    y1: 265.662,
    x2: 141.768,
    y2: 248.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_761_1544",
    x1: 136.312,
    y1: 261.485,
    x2: 155.781,
    y2: 236.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_761_1544",
    x1: 178.236,
    y1: 236.273,
    x2: 194.41,
    y2: 269.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#893976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_761_1544",
    x1: 134.619,
    y1: 249.624,
    x2: 108.139,
    y2: 116.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_761_1544",
    x1: 60.4272,
    y1: 157.798,
    x2: 84.3017,
    y2: 171.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_761_1544",
    x1: 80.3302,
    y1: 197.842,
    x2: 89.3851,
    y2: 149.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_761_1544",
    x1: 146.241,
    y1: 209.135,
    x2: 141.24,
    y2: 160.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_761_1544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 318,
    height: 314,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundArrecadacoes);
export default __webpack_public_path__ + "static/media/background-arrecadacoes.28b50de9f4320bf1faa929437df893cc.svg";
export { ForwardRef as ReactComponent };